import Vue from 'vue'

Vue.component('base-layout', () => import('./Base'))
Vue.component('default-layout', () => import('./Default'))